/*
 * <pdp-ritual>: "How to use" steps that play one after another, like stories.
 * The active step's bar fills over STEP_MS, then the next step starts.
 * Plays only while on screen, pauses on hover / focus, and stops for reduced motion.
 */
if (!customElements.get('pdp-ritual')) {
  const STEP_MS = 4500;

  class PdpRitual extends HTMLElement {
    connectedCallback() {
      this.steps = Array.from(this.querySelectorAll('[data-ritual-step]'));
      this.bars = Array.from(this.querySelectorAll('[data-ritual-bar]'));
      this.icons = Array.from(this.querySelectorAll('[data-ritual-icon]'));
      this.images = Array.from(this.querySelectorAll('.pdpx-ritual__img'));
      this.big = this.querySelector('[data-ritual-big]');
      this.ring = this.querySelector('[data-ritual-ring]');
      this.index = 0;
      this.autoplay = !window.matchMedia('(prefers-reduced-motion: reduce)').matches && this.steps.length > 1;

      this.style.setProperty('--ritual-ms', `${STEP_MS}ms`);

      this.steps.forEach((step, i) => {
        step.addEventListener('click', () => this.go(i));
      });

      this.bars.forEach((bar) => {
        bar.addEventListener('animationend', () => this.go((this.index + 1) % this.steps.length));
      });

      this.addEventListener('mouseenter', () => this.classList.add('is-paused'));
      this.addEventListener('mouseleave', () => this.classList.remove('is-paused'));
      this.addEventListener('focusin', () => this.classList.add('is-paused'));
      this.addEventListener('focusout', () => this.classList.remove('is-paused'));

      // Only run while visible; a hidden tab panel counts as not visible.
      this.observer = new IntersectionObserver((entries) => {
        this.classList.toggle('is-playing', this.autoplay && entries[0].isIntersecting);
      });
      this.observer.observe(this);

      this.go(0);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    go(index) {
      this.index = index;
      const count = this.steps.length;

      this.steps.forEach((step, i) => {
        const active = i === index;
        step.classList.toggle('is-active', active);
        step.classList.toggle('is-done', i < index);
        if (active) {
          step.setAttribute('aria-current', 'step');
        } else {
          step.removeAttribute('aria-current');
        }
      });

      // Restart the active bar's fill animation.
      this.bars.forEach((bar) => {
        bar.style.animation = 'none';
      });
      if (this.bars[index]) {
        void this.bars[index].offsetWidth;
        this.bars[index].style.animation = '';
      }

      this.icons.forEach((icon, i) => icon.classList.toggle('is-active', i === index));
      this.images.forEach((image, i) => image.classList.toggle('is-active', i === index));

      if (this.big) this.big.textContent = String(index + 1).padStart(2, '0');
      if (this.ring) this.ring.style.strokeDashoffset = String(100 - ((index + 1) / count) * 100);
    }
  }

  customElements.define('pdp-ritual', PdpRitual);
}
